import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import React from 'react';

const useStyles = makeStyles(() =>
    createStyles({
        grid: {
            maxWidth: '1100px',
            justifyContent: 'center',
        },
    }),
);

const UiCardGrid: React.FC<{ maxCardWidth: string; style?: React.CSSProperties; gap?: string }> = ({
    children, maxCardWidth, style, gap = '24px',
}) => {
    const classes = useStyles();

    return <Grid
        className={classes.grid}
        role="grid"
        sx={{
            display: 'grid',
            gridTemplateColumns: `repeat(auto-fill, minmax(250px, ${maxCardWidth}))`,
            gridAutoFlow: 'row',
            gap,
        }}
        style={style}>
        {children}
    </Grid>;
};

export default UiCardGrid;
